var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMultiUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.307 18.9194C20.3614 18.9266 20.4159 18.934 20.4703 18.9417L20.7438 18.9801C21.9346 19.1472 23 18.2395 23 17.0579V16.1562C23 15.3111 22.4592 14.5573 21.649 14.2731C20.7129 13.9447 19.7466 13.7309 18.7711 13.6316C19.789 14.3675 20.4203 15.5592 20.4203 16.8594V17.979C20.4203 18.3041 20.3809 18.619 20.307 18.9194ZM16.1812 12.432C16.5868 12.5995 17.0324 12.692 17.5 12.692C19.3813 12.692 20.9064 11.1939 20.9064 9.34597C20.9064 7.49801 19.3813 5.99994 17.5 5.99994C17.4443 5.99994 17.3889 6.00125 17.3338 6.00385C17.6759 6.73246 17.8671 7.546 17.8671 8.40419C17.8671 9.9807 17.2219 11.4065 16.1812 12.432Z",
    fill: "#2A2A2B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.07387 18.9194C4.01942 18.9266 3.96499 18.934 3.91058 18.9417L3.63707 18.9801C2.44625 19.1472 1.38084 18.2395 1.38084 17.0579V16.1562C1.38084 15.3111 1.92166 14.5573 2.73185 14.2731C3.66791 13.9447 4.63427 13.7309 5.60979 13.6316C4.59191 14.3675 3.96057 15.5592 3.96057 16.8594V17.979C3.96057 18.3041 3.99992 18.619 4.07387 18.9194ZM8.19971 12.432C7.79406 12.5995 7.34845 12.692 6.88084 12.692C4.99952 12.692 3.47442 11.1939 3.47442 9.34597C3.47442 7.49801 4.99952 5.99994 6.88084 5.99994C6.93657 5.99994 6.992 6.00125 7.04707 6.00385C6.70496 6.73246 6.51377 7.546 6.51377 8.40419C6.51377 9.9807 7.15896 11.4065 8.19971 12.432Z",
    fill: "#2A2A2B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3671 8.40419C16.3671 6.10986 14.5071 4.24994 12.2128 4.24994C9.91848 4.24994 8.05856 6.10986 8.05856 8.40419C8.05856 10.6985 9.91848 12.5584 12.2128 12.5584C14.5071 12.5584 16.3671 10.6985 16.3671 8.40419Z",
    fill: "#2A2A2B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.15298 14.5214C10.425 13.3528 14.0006 13.3528 17.2727 14.5214C18.2607 14.8743 18.9203 15.8102 18.9203 16.8594V17.979C18.9203 19.4459 17.621 20.5728 16.1687 20.3654L15.8351 20.3177C13.4325 19.9745 10.9932 19.9745 8.59049 20.3177L8.25693 20.3654C6.80468 20.5728 5.50537 19.4459 5.50537 17.979V16.8594C5.50537 15.8102 6.16492 14.8743 7.15298 14.5214Z",
    fill: "#2A2A2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiUsers);
export default __webpack_public_path__ + "static/media/MultiUsers.c9b329948ccc9229adfe80542debad4f.svg";
export { ForwardRef as ReactComponent };